/**
 * Utility functions for heading structure components
 */

/**
 * Decodes HTML entities in a text string safely
 */
export const decodeHtmlEntities = text => {
  if (!text) {
    return '';
  }
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  return doc.documentElement.textContent || '';
};

/**
 * Creates a composite key for a heading element, used to match headings with AI suggestions.
 */
export const makeHeadingElementKey = (id, attributeId, uiElementId) => `${id ?? ''}:${attributeId ?? ''}:${uiElementId ?? ''}`;
const H_TAG_REGEX = /<h(?<n>[1-6])\b/u;

/**
 * Extracts the numeric heading level (1–6) from either a bare tag name
 * (e.g. "h2", "H3") or an HTML string containing a heading element
 * (e.g. "<h1 class=...>Title</h1>"). Returns undefined for non-heading
 * inputs (e.g. "p", "<div>...</div>").
 */
export const extractHeadingTagNumber = tagOrHtml => {
  var _match$groups;
  const trimmed = tagOrHtml.trim().toLowerCase();
  if (/^h[1-6]$/.test(trimmed)) {
    return parseInt(trimmed.slice(1), 10);
  }
  const match = H_TAG_REGEX.exec(tagOrHtml);
  return match != null && (_match$groups = match.groups) != null && _match$groups.n ? parseInt(match.groups.n, 10) : undefined;
};

/**
 * Rewrites a heading element to use a new tag, preserving attributes and inner HTML.
 * Returns the resulting outerHTML string. UI-only utility (no editor side effects).
 */
export const copyHeadingTagContent = (newHeadingTag, oldHeading) => {
  const newHeading = window.document.createElement(newHeadingTag);
  for (const attr of oldHeading.attributes) {
    newHeading.setAttribute(attr.name, attr.value);
  }
  newHeading.innerHTML = oldHeading.innerHTML;
  return newHeading.outerHTML;
};

/**
 * Extracts text content from HTML string, removing tags and normalizing whitespace
 */
export const getHeadingContent = htmlString => {
  let textContent = htmlString.replace(/<[^>]+>/g, '');
  textContent = textContent.replace(/&nbsp;/g, ' ');
  textContent = textContent.replace(/\s+/g, ' ').trim();
  return textContent;
};

/**
 * Creates heading dropdown options with the provided text labels
 * @param labels - Object with label text for each heading type
 * @returns Array of dropdown options
 */
export const createHeadingDropdownOptions = labels => [{
  id: 'h1',
  label: labels.h1
}, {
  id: 'h2',
  label: labels.h2
}, {
  id: 'h3',
  label: labels.h3
}, {
  id: 'h4',
  label: labels.h4
}, {
  id: 'h5',
  label: labels.h5
}, {
  id: 'h6',
  label: labels.h6
}, {
  id: 'p',
  label: labels.p
}];

/**
 * Extracts heading dropdown options from HeadingStructureTexts
 */
export const getHeadingDropdownOptions = texts => {
  return texts.dropdownOptions;
};
//# sourceMappingURL=heading-structure-utils.js.map